<template>
    <div class="forget-password">
      <LayoutHeader></LayoutHeader>
      <div class="forget-password__container"
           v-if="step !== 2">
        <div class="forget-password__container-header
        flex flex--align-center flex--justify-between">
          <div v-if="step === 0">
            <h3>用户身份验证</h3>
            <p>请先输入已绑定的手机号码与短信验证码</p>
          </div>
          <div v-if="step === 1">
            <h3>密码重置</h3>
          </div>
          <router-link to="/login" replace>
            <v-icon type="iconclear-24px"></v-icon>
          </router-link>
        </div>
        <div class="forget-password__container-body">
          <Step1 @on-submit="handleSubmit"
                 v-if="step === 0"></Step1>
          <Step2 @on-submit="handleSubmit"
                 :token="token"
                 v-if="step === 1"></Step2>
        </div>
      </div>
      <vSuccessModal title="密码重置成功!"
                     v-if="step === 2"></vSuccessModal>
    </div>
</template>

<script>
import LayoutHeader from '@/components/layout/layoutHeader.vue';
import Step1 from './step1.vue';
import Step2 from './step2.vue';

export default {
  name: 'forgetPassword',
  components: {
    LayoutHeader,
    Step1,
    Step2,
  },
  data() {
    return {
      step: 0,
      token: '',
    };
  },
  methods: {
    handleSubmit(token = '') {
      this.token = token;
      this.step += 1;
    },
  },
};
</script>

<style lang="less">
  @prefix: ~'forget-password';
  .@{prefix}{
    height: 100vh;
    width: 100vw;
    background-image: url("../../assets/login/bg-login.jpeg");
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
    position: relative;
    min-height: 590px;
    &__container{
      width: 560px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: -40px;
      box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .1),
      0 6px 30px 5px rgba(0, 0, 0, .08),
      0 8px 10px 0 rgba(0, 0, 0, .16);
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      &-header{
        height: 56px;
        background-color: rgb(81, 69, 139);
        padding: 0 16px;
        h3{
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
        }
        p{
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 18px;
          &:after{
            content: ' * ';
            color: rgb(255, 152, 0);
          }
        }
        .v-icon{
          color: #fff;
          cursor: pointer;
        }
      }
      &-body{
        padding: 22px 16px 46px;
        .@{prefix}__msg-valid-btn{
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          padding: 0;
          box-shadow: none;
          height: 36px;
          font-size: 14px;
          font-weight: 500;
          color: @primary-color;
          &[disabled]{
            color: #bfbfbf;
            background-color: transparent;
            &:hover{
              color: #bfbfbf;
              background-color: transparent;
            }
          }
          &:hover{
            background-color: transparent;
          }
        }
        .ivu-form-item{
          margin-bottom: 36px;
          &.@{prefix}__error-agreement{
            .ivu-checkbox-wrapper{
              span{
                color: rgb(255, 152, 0);
              }
            }
            .ivu-checkbox-inner{
              border-color: rgb(255, 152, 0);
            }
            .@{prefix}__agreement-btn{
              color: rgb(255, 152, 0);
            }
          }
        }
        .ivu-input {
          border-color: rgba(0, 0, 0, 0.12);
          border-radius: 8px;
          height: 36px;
          line-height: 36px;
          padding: 0 16px;
          color: #000;

          &:focus {
            border-color: @primary-color;
          }
        }
        .ivu-btn-long{
          padding: 0;
          height: 36px;
          font-size: 14px;
          font-weight: 500;
          &[disabled] {
            background-color: rgba(0, 0, 0, 0.12);
            border: none;
            color: rgba(0, 0, 0, 0.26);
            &:hover{
              background-color: rgba(0, 0, 0, 0.12);
              border: none;
              color: rgba(0, 0, 0, 0.26);
            }
          }
        }
        .ivu-input-suffix i{
          line-height: 36px;
          font-size: 20px;
        }
      }
    }
    &__valid-form-item.ivu-form-item{
      padding-right: 144px;
      position: relative;
      margin-bottom: 40px;
    }
    &__valid-img{
      position: absolute;
      width: 140px;
      text-align: right;
      top: 0;
      right: -144px;
      img{
        width: 103px;
        height: 34px;
        vertical-align: middle;
      }
      p{
        line-height: 20px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 500;
        cursor: pointer;
        &:hover{
          color: @primary-color;
        }
      }
    }
    &__msg-valid-item{
      position: relative;
    }
  }
</style>
